<script lang="ts">
  export let placeholder: string = '';
  export let value: string = '';
  export let label: string = '';
  export let disabled: boolean = false;
  export let required: boolean = false;
  export let error: string = '';
  export let fullWidth: boolean = false;
  export let readonly: boolean = false;
  export let rows: number = 4;
</script>

<div class="textarea-wrapper" class:full-width={fullWidth}>
  {#if label}
    <label class="textarea-label" for={label}>
      {label}
      {#if required}<span class="required">*</span>{/if}
    </label>
  {/if}
  
  <textarea
    {placeholder}
    {disabled}
    {readonly}
    {required}
    {rows}
    id={label}
    class="textarea-field"
    class:error={error}
    bind:value
    on:input
    on:blur
    on:focus
    on:keydown
    on:keyup
  ></textarea>
  
  {#if error}
    <span class="error-message">{error}</span>
  {/if}
</div>

<style>
  .textarea-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .full-width {
    width: 100%;
  }
  
  .textarea-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
  }
  
  .required {
    color: #ef4444;
  }
  
  .textarea-field {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.875rem;
    background-color: white;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-family: inherit;
    resize: vertical;
    box-sizing: border-box;
  }
  
  .textarea-field:focus {
    outline: none;
    border-color: #f0b429;
    box-shadow: 0 0 0 3px rgba(240, 180, 41, 0.1);
  }
  
  .textarea-field:disabled {
    background-color: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }
  
  .textarea-field:read-only {
    background-color: #f9fafb;
    cursor: default;
  }
  
  .textarea-field.error {
    border-color: #ef4444;
  }
  
  .textarea-field.error:focus {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
  }
  
  .error-message {
    font-size: 0.75rem;
    color: #ef4444;
  }
</style> 